import FingerprintJS from "@fingerprintjs/fingerprintjs";

import {
  ACTIVITY_KEY,
  USER_PROFILE_DATA_KEY,
  BROWSER_FINGER_PRINT_KEY,
  LAST_ACTIVITY_SYNC,
} from "../constants";

import { asyncLocalStorageGet, asyncLocalStorageSet } from "./common";

const fpPromise = FingerprintJS.load();
const MAX_LOG_ENTRIES = 500; // keep only the last 500 logs

const log = async (payload = []) => {
  let activities = localStorageGet(ACTIVITY_KEY);

  if (payload.length === 1 && checkActivityPayload(payload[0])) {
    // When only one event is present in payload.
    activities[payload[0].timeStamp] = payload;
  } else if (payload.length > 1) {
    // When multiple event is present in payload.
    const filteredPayload = payload.filter((activity) =>
      checkActivityPayload(activity)
    );
    activities[filteredPayload[0].timeStamp] = filteredPayload;
  }
  const keys = Object.keys(activities).sort();
  if (keys.length > MAX_LOG_ENTRIES) {
    const excess = keys.length - MAX_LOG_ENTRIES;
    for (let i = 0; i < excess; i++) {
      delete activities[keys[i]];
    }
  }

  await asyncLocalStorageSet(ACTIVITY_KEY, activities);
  return;
};

const get = (eventName = "", payload = {}) => {
  const filteredActivities = filterAccordingToEventName(eventName);
  let activities = [];

  if (eventName === "pageVisit" && payload.hasOwnProperty("pathname")) {
    activities = filteredActivities.filter(
      (activity) => activity["payload"]["to"] === payload["pathname"]
    );
  } else {
    activities = [...filteredActivities];
  }

  return activities;
};

const logUserProfileData = async (payload = {}) => {
  let userProfileData = await asyncLocalStorageGet(USER_PROFILE_DATA_KEY);
  let data = {};

  if (!Object.keys(userProfileData).length) {
    data = {
      state: "ANONYMOUS_PROFILE",
    };
  } else if (Object.keys(payload).length) {
    data = {
      ...userProfileData,
      ...payload,
    };
  }

  if (Object.keys(data).length) {
    await asyncLocalStorageSet(USER_PROFILE_DATA_KEY, data);
  }

  return;
};

const getUserProfileData = async () => {
  return await asyncLocalStorageGet(USER_PROFILE_DATA_KEY);
};

const logFingerPrint = async () => {
  let browserFingerPrint = await asyncLocalStorageGet(BROWSER_FINGER_PRINT_KEY);
  if (!Object.keys(browserFingerPrint).length) {
    browserFingerPrint["fingerPrint"] = await generateFingerPrint();
    await asyncLocalStorageSet(BROWSER_FINGER_PRINT_KEY, browserFingerPrint);
  }
  return;
};

const initializeLastActivitySync = async () => {
  let lastActivitySync = await asyncLocalStorageGet(LAST_ACTIVITY_SYNC);
  if (lastActivitySync.constructor === Object) {
    asyncLocalStorageSet(LAST_ACTIVITY_SYNC, "");
  }
  return;
};

const initializeActivityLogger = async () => {
  await logUserProfileData({});
  await logFingerPrint();
  await initializeLastActivitySync();
};

/**
 * Helper functions
 */

const localStorageGet = (key) => {
  const data = window.localStorage.getItem(key);
  return data ? JSON.parse(data) : {};
};

const filterAccordingToEventName = async (eventName = "") => {
  const activities = await asyncLocalStorageGet(ACTIVITY_KEY);
  const filteredActivity = [];

  // eslint-disable-next-line no-unused-vars
  for (let [key, value] of Object.entries(activities)) {
    // This loop will run only 1 time in most of the cases.
    // As multiple events happening at same time have
    // less probability
    for (const event of value) {
      if (event.eventName === eventName) {
        filteredActivity.push(event);
      }
    }
  }
  return filteredActivity;
};

const checkActivityPayload = (payload) => {
  return (
    payload.hasOwnProperty("timeStamp") && payload.hasOwnProperty("eventName")
  );
};

const generateFingerPrint = async () => {
  // Get the visitor identifier when you need it.
  const fp = await fpPromise;
  const result = await fp.get();

  // This is the visitor identifier:
  return result.visitorId;
};

const activity = {
  log,
  get,
  logUserProfileData,
  getUserProfileData,
  logFingerPrint,
  initializeActivityLogger,
};
export default activity;
